import { TOGGLE_UPDATES } from '.';

export default () => ({
  type: TOGGLE_UPDATES,
});
